
{
  "fr": {
    "configuratorProject": {
      "button": {
        "label": "Enregistrer le projet"
      },
      "authModalTitle": "Connectez-vous pour enregistrer votre projet",
      "error": "Une erreur s'est produite pendant la création de votre projet. Veuillez réessayer ou nous contacter."
    }
  }
}
